<template>
    <div class="page">
        <div class="header">
            <div class="logo">
                <img :src="icon" alt="" />
            </div>
            <div class="title">{{ title }}</div>
        </div>
        <div class="form">
            <div class="title">
                <img src="../../assets/my/in1.png" alt="" />
                <div class="name">账号</div>
            </div>
            <van-field
                class="input"
                v-model="form.username"
                border
                placeholder="请输入账号"
            />
            <div class="title password">
                <img src="../../assets/my/in2.png" alt="" />
                <div class="name">密码</div>
            </div>
            <van-field
                class="input"
                type="password"
                v-model="form.password"
                border
                placeholder="请输入密码"
            />

            <div class="radio">
                <van-checkbox v-model="checked" icon-size="15px">
                    <div class="tips">
                        我已同意接受 <span>用户协议</span> 和
                        <span>隐私政策</span>
                    </div>
                </van-checkbox>
            </div>
            <van-button
                class="button"
                :loading="button.loading"
                :disabled="button.disabled"
                @click="submit"
                :loading-text="button.text"
            >
                {{ button.text }}
            </van-button>
            <div v-if="is_recharge_type==1" class="register" @click="goRegister">没有账号，前往注册</div>
        </div>
        <div class="install-btn" v-show="isShowInstallBtn">
            <div class="text-box">
                <van-icon name="bookmark" />
                <div class="text">网页可添加到手机桌面</div>
            </div>
            <div id="install-btn-item" class="btn">添加</div>
        </div>
    </div>
</template>

<script>
import { getCookie, setCookie } from "@/utils";
import { userLogin } from "../../api/scrm.js";
import { Toast } from "vant";
export default {
    data() {
        return {
            button: { loading: false, disable: false, text: "登 录" },
            form: {
                username: "", //15988888888  123456
                password: "",
            },
            checked: false,
            title: "",
            icon: "",
            isShowInstallBtn: false,
            is_recharge_type:process.env.VUE_APP_IS_RECHARGE_TYPE,
        };
    },
    created() {
        console.log(process.env);
        // 在 created 生命周期中设置环境变量
        this.title = process.env.VUE_APP_APP_NAME || "";
        this.icon = require(`../../assets/images/${process.env.VUE_APP_APP_ICON}`);

        // this.form = {username: '13668889999', password: '123456'}; //经销商
        // this.form = {username: '13356885555', password: '123456'}; //群管
        this.handleInstallBtn();
    },
    methods: {
        handleInstallBtn() {
            console.log(
                "是否在离线模式下",
                window.matchMedia("(display-mode: standalone)").matches
            );
            try {
                if (!window.matchMedia("(display-mode: standalone)").matches) {
                    let deferredPrompt = null;
                    window.addEventListener("beforeinstallprompt", (e) => {
                        console.log("beforeinstallprompt", e);
                        e.preventDefault();
                        deferredPrompt = e;
                        this.isShowInstallBtn = true;
                        let installBtnItem =
                            document.getElementById("install-btn-item");
                        installBtnItem.addEventListener("click", () => {
                            deferredPrompt.prompt();
                            deferredPrompt.userChoice.then((choiceResult) => {
                                deferredPrompt = null;
                                this.isShowInstallBtn = false;
                            });
                        });
                    });
                }
            } catch (error) {
                console.log("添加弹窗error", error);
            }
        },
        login() {
            console.log("login");
        },
        submit() {
            if (this.form.username === "") {
                return Toast({ position: "top", message: "请输入账号" });
            }
            if (this.form.password === "") {
                return Toast({ position: "top", message: "请输入密码" });
            }
            if (!this.checked) {
                return Toast({
                    position: "top",
                    message: "请先同意用户协议和隐私政策",
                });
            }
            this.button.disabled = true;
            this.button.loading = true;
            this.button.text = "登录中...";
            userLogin(this.form)
                .then((res) => {
                    if (res.code == 1) {
                        res.data.isDealer = res.data.role == 1;
                        setCookie("personbench_token", res.data.token);
                        setCookie("person", JSON.stringify(res.data));
                        localStorage.setItem(
                            "userDetails",
                            JSON.stringify(res.data)
                        );
                        this.$router.push({
                            name: "home",
                        });
                    } else {
                        Toast.fail(res.msg);
                    }

                    // this.button.disabled = false;
                    // this.button.loading = false;
                    // this.button.text = '登 录';
                    // if (res.status) {
                    //     this.form.captcha = '';
                    //     this.$func.error(res.message);
                    // } else {
                    //     this.$store.dispatch('userLogin', res.data).then(() => {
                    //         this.$func.success(res.message).then(() => {
                    //             this.$router.push({name: 'main'});
                    //         });
                    //     });
                    // }
                })
                .finally((e) => {
                    this.button.disabled = false;
                    this.button.loading = false;
                    this.button.text = "登 录";
                });
        },
        goRegister(){
            this.$router.push({name: 'register'});
        }
    },
};
</script>

<style scoped lang="less">
/* iOS 全局样式修复 */
@supports (-webkit-touch-callout: none) {
    /* iOS 专用样式 */
    .page .form .input /deep/ input,
    .page .form .input /deep/ .van-field__control {
        -webkit-appearance: none !important;
        appearance: none !important;
        border-radius: var(--base-px-24) !important;
        -webkit-border-radius: var(--base-px-24) !important;
    }
    
    .page .form .button /deep/ .van-button {
        -webkit-appearance: none !important;
        appearance: none !important;
        -webkit-tap-highlight-color: transparent !important;
    }
}

.page {
    min-height: 100vh;
    width: 100%;
    background: #2b62cc;
    padding-top: var(--base-px-55);
    display: flex;
    flex-direction: column;
    -webkit-tap-highlight-color: transparent;
}

.page .header {
    height: var(--base-px-178);
    text-align: center;
    flex-shrink: 0;
}

.page .header .logo img {
    width: var(--base-px-70);
    height: var(--base-px-70);
    border-radius: var(--base-px-10);
}

.page .header .title {
    margin-top: var(--base-px-15);
    color: #ffffff;
    font-weight: bold;
    font-size: var(--base-px-20);
}

.page .form {
    background: #ffffff;
    border-radius: var(--base-px-35) var(--base-px-35) 0 0;
    position: relative;
    overflow: hidden;
    flex: 1;
    padding: var(--base-px-50) var(--base-px-25) var(--base-px-25);
    display: flex;
    flex-direction: column;
}
.page .form .title {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    font-size: var(--base-px-14);
    /*font-weight: bold;*/
    margin-bottom: var(--base-px-10);
}
.page .form .title.password {
    margin-top: var(--base-px-25);
}
.page .form .title img {
    width: var(--base-px-12);
    margin-right: var(--base-px-5);
}
.page .form .input {
    height: var(--base-px-45);
    background: #f5f7f7;
    border-radius: var(--base-px-24);
    -webkit-appearance: none;
    appearance: none;
    border: none;
    overflow: hidden;
}

/* iOS 输入框样式修复 */
.page .form .input /deep/ .van-field__control {
    -webkit-appearance: none !important;
    appearance: none !important;
    border: none !important;
    outline: none !important;
    background: transparent !important;
    font-size: var(--base-px-14) !important;
    border-radius: 0 !important;
    -webkit-border-radius: 0 !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.page .form .input /deep/ .van-field__body {
    -webkit-appearance: none;
    appearance: none;
    height: 100%;
}

.page .form .input /deep/ input {
    -webkit-appearance: none !important;
    appearance: none !important;
    border: none !important;
    outline: none !important;
    background: transparent !important;
    font-size: var(--base-px-14) !important;
    -webkit-tap-highlight-color: transparent !important;
    border-radius: 0 !important;
    -webkit-border-radius: 0 !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
}

.page .form .input /deep/ input:focus {
    outline: none !important;
    border: none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.page .form .input /deep/ input::-webkit-input-placeholder {
    color: #999;
    opacity: 1;
}

.page .form .input /deep/ input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #f5f7f7 inset !important;
    -webkit-text-fill-color: #333 !important;
}
.page .form .radio {
    margin-left: var(--base-px-10);
    margin-top: var(--base-px-85);
}
.page .form .tips {
    font-size: var(--base-px-12);
    font-weight: 400;
    color: #666666;
}
.page .form .tips span {
    color: #117de9;
}
.page .form .button {
    width: 100%;
    background: linear-gradient(to right, #117de9, #2b62cc);
    color: #ffffff;
    font-weight: bold;
    border-radius: var(--base-px-30);
    margin-top: var(--base-px-15);
    -webkit-appearance: none !important;
    appearance: none !important;
    border: none !important;
    outline: none !important;
    -webkit-tap-highlight-color: transparent !important;
}

/* iOS 按钮样式修复 */
.page .form .button /deep/ .van-button {
    -webkit-appearance: none !important;
    appearance: none !important;
    border: none !important;
    outline: none !important;
    background: linear-gradient(to right, #117de9, #2b62cc) !important;
    border-radius: var(--base-px-30) !important;
    -webkit-border-radius: var(--base-px-30) !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -webkit-tap-highlight-color: transparent !important;
}

.page .form .button /deep/ .van-button__content {
    -webkit-appearance: none !important;
    appearance: none !important;
    color: #ffffff !important;
}

.page .form .button /deep/ .van-button:active {
    opacity: 0.8;
    transform: scale(0.98);
}

.page .form .button /deep/ .van-button:focus {
    outline: none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
}

.page .form .button:active {
    opacity: 0.8;
    transform: scale(0.98);
}

.page .form .button:focus {
    outline: none;
    -webkit-appearance: none;
    appearance: none;
}
.page .install-btn {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, #117de9 0%, #2b62cc 50%, #117de9 100%);
    background-size: 200% 200%;
    border-radius: var(--base-px-10) var(--base-px-10) 0 0;
    padding: var(--base-px-20) var(--base-px-25);
    font-size: var(--base-px-14);
    color: #ffffff;
    font-weight: bold;
    box-shadow: 0 -4px 20px rgba(17, 125, 233, 0.3),
        0 2px 10px rgba(0, 0, 0, 0.1) inset;
    cursor: pointer;
    z-index: 1000;
    overflow: hidden;
    transform: translateY(100%); /* 初始位置在屏幕外 */
    animation: install-btn-animation 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)
        forwards 0.5s; /* 延迟0.5秒弹出 */
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 光泽效果（高光） */
.page .install-btn::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 50%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.3),
        transparent
    );
    animation: shine-effect 3s ease-in-out infinite 1.5s; /* 延迟1.5秒开始 */
}

/* 脉冲呼吸效果 */
@keyframes pulse-glow {
    0%,
    100% {
        box-shadow: 0 -4px 20px rgba(17, 125, 233, 0.3),
            0 2px 10px rgba(255, 255, 255, 0.1) inset;
    }
    50% {
        box-shadow: 0 -4px 30px rgba(17, 125, 233, 0.5),
            0 2px 15px rgba(255, 255, 255, 0.2) inset;
    }
}

/* 光泽动画 */
@keyframes shine-effect {
    0% {
        left: -100%;
    }
    20%,
    100% {
        left: 200%;
    }
}

/* 按钮弹出动画（带弹性效果） */
@keyframes install-btn-animation {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }
    60% {
        transform: translateY(-15px); /* 向上弹一点 */
        opacity: 1;
    }
    80% {
        transform: translateY(5px); /* 稍微回弹 */
    }
    100% {
        transform: translateY(0);
        opacity: 1;
        animation: pulse-glow 2s ease-in-out infinite; /* 持续脉动 */
    }
}

/* 背景渐变流动动画 */
.page .install-btn {
    animation: install-btn-animation 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)
            forwards 0.5s,
        pulse-glow 2s ease-in-out infinite 1.3s,
        /* 延迟1.3秒开始脉动 */ gradient-flow 4s linear infinite 1.3s; /* 渐变背景流动 */
}

@keyframes gradient-flow {
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
}

/* 悬停交互效果 */
.page .install-btn:hover {
    transform: scale(1.02) translateY(0);
    background: linear-gradient(135deg, #2b8cf5 0%, #3a72e0 50%, #2b8cf5 100%);
    box-shadow: 0 -6px 30px rgba(17, 125, 233, 0.4),
        0 2px 15px rgba(255, 255, 255, 0.3) inset;
    animation-play-state: paused; /* 悬停时暂停所有动画 */
}

.page .install-btn:active {
    transform: scale(0.98) translateY(0);
    transition: transform 0.1s ease;
    background: linear-gradient(135deg, #0f6bd6 0%, #1a52b8 50%, #0f6bd6 100%);
}

.page .install-btn .text-box {
    display: flex;
    align-items: center;
    justify-content: center;
}
.page .install-btn .text-box .text {
    margin-left: var(--base-px-5);
}
.page .install-btn .btn {
    width: var(--base-px-60);
    height: var(--base-px-30);
    background: #ffffff;
    border-radius: var(--base-px-10);
    color: #117de9;
    line-height: var(--base-px-30);
    font-weight: bold;
    text-align: center;
}
.register{
    color: #117de9;
    text-align: right;
    margin-top: var(--base-px-20);
    font-size: var(--base-px-12);
    text-decoration: underline;
}
</style>
